import { Property } from "../../../../../RadObject";
import { Evaluator } from "../../../SeriouslyRAD.Framework/Evaluation/Evaluator";
import { EvaluatorPropertyValues, IEvaluator } from "../../../SeriouslyRAD.Framework/Evaluation/IEvaluator";
import { NAMESPACE } from "./_Namespace";

export type FalseEvaluatorPropertyValues =
    EvaluatorPropertyValues
    & {
    };

export type FalseEvaluatorProperties = {
    [name in keyof FalseEvaluatorPropertyValues]: Property<FalseEvaluatorPropertyValues[name]>
};

export interface IFalseEvaluator extends IEvaluator, FalseEvaluatorProperties
{
}

export class FalseEvaluator extends Evaluator<FalseEvaluatorPropertyValues> implements IFalseEvaluator
{
    public static override classNamespace = NAMESPACE + "FalseEvaluator";
    public static override className = "FalseEvaluator";

    // #region Overrides

    public override evaluate()
    {
        const
            value = false;

        this.value.set(value);

        return value;
    }

    // #endregion
}

